import React, { useState, useEffect } from 'react';
import Logo from '@assets/images/bell-icon.svg';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Theme, Badge } from '@mui/material';
import { commonService } from '@services/common.service';
import { useHistory } from 'react-router-dom'
import { isCustomer, isBusiness } from '@shared/helpers/global.helper';

const useStyles = makeStyles((theme: Theme) => ({
    badge: {
        fontSize: '12px'
    }
}));

export const BellIcon = ({ style = { height: '20px', width: '20px' } }: any) => {
    const theme = useTheme();
    const classes = useStyles();
    const [unreadCount, setUnreadCount] = useState();

    const history = useHistory()
    useEffect(() => {

        const getUnreadNotification = async () => {
            const response: any = await commonService.getUnreadNotifications();
            if(response?.data?.data[0]?.num_unread) {
                setUnreadCount(response.data.data[0].num_unread)
            }
        };

        getUnreadNotification().catch(console.error);

        const unlisten = history.listen((location) => {
            if (!location.pathname.startsWith('/auth/login')) {
                if (isCustomer()) {
                    getUnreadNotification().catch(console.error);
                }
            }
        })

        return unlisten;
    }, [])

    return (
        <Badge badgeContent={unreadCount} color="error" className={classes.badge}>
            <img src={Logo} alt='Profile Logo' style={style} />
        </Badge>

    )
}
